import {
  Flex,
  Modal,
  PrimaryButton,
  SecondaryButton,
  useAssistiveHideSiblings,
  useDisableBodyScroll,
  useFocusTrap,
  useInitialFocus,
  useModalModel,
  useReturnFocus
} from '@workday/canvas-kit-react'
import React from 'react'
import { PrimaryButtonColors } from './CanvasThemes'
import { ReactElement } from 'react'

export interface ConfirmationProps {
  title: string
  message: string | ReactElement
  onCancel: () => void
  onConfirm: () => void
  confirmLabel?: string
  addOtherButton?: boolean
  onOtherButton?: () => void
  otherLabel?: string
}

export const Confirmation = (props: ConfirmationProps) => {
  const confirmationButtonClickHandler = () => {
    props.onConfirm()
  }
  const otherButtonClickHandler = () => {
    props.onOtherButton && props.onOtherButton()
  }

  const cancelButtonClickHandler = () => {
    props.onCancel()
  }

  const model = useModalModel()
  useInitialFocus(model)
  useReturnFocus(model)
  useFocusTrap(model)
  useAssistiveHideSiblings(model)
  useDisableBodyScroll(model)
  model.state.visibility = 'visible'

  return (
    <Modal model={model}>
      <Modal.Overlay>
        <Modal.Card>
          {props.title.length > 0 && <Modal.Heading>{props.title}</Modal.Heading>}
          <Modal.Body>{props.message}</Modal.Body>
          <Flex flexDirection="row" columnGap="s">
            <SecondaryButton as="button" onClick={cancelButtonClickHandler}>
              Cancel
            </SecondaryButton>
            <PrimaryButton as="button" onClick={confirmationButtonClickHandler} colors={PrimaryButtonColors}>
              {props.confirmLabel ? props.confirmLabel : 'Yes'}
            </PrimaryButton>
            {props.addOtherButton && (
              <PrimaryButton as="button" onClick={otherButtonClickHandler} colors={PrimaryButtonColors}>
                {props.otherLabel ? props.otherLabel : 'No'}
              </PrimaryButton>
            )}
          </Flex>
        </Modal.Card>
      </Modal.Overlay>
    </Modal>
  )
}
